import type { FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { IdleQueue } from "scmp-app/components/common/idle-queue";
import { DynamicHeaderAvatar } from "scmp-app/components/header/dynamics";
import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { DynamicHomeHeaderAvatar } from "scmp-app/components/home/header/dynamics";

import { AvatarContainer } from "./styles";

export type HeaderFeaturesDashboardProps = {
  hideOnSwap?: SwapCondition;
  isHomepage?: boolean;
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
};

export const HeaderFeaturesDashboard: FunctionComponent<HeaderFeaturesDashboardProps> = ({
  hideOnSwap,
  isHomepage,
  shouldSwap,
  showIn,
}) => (
  <ClientSideSuspense>
    {isHomepage ? (
      <DynamicHomeHeaderAvatar />
    ) : (
      <AvatarContainer $hideOnSwap={hideOnSwap} $shouldSwap={shouldSwap} $showIn={showIn}>
        <IdleQueue>
          <DynamicHeaderAvatar />
        </IdleQueue>
      </AvatarContainer>
    )}
  </ClientSideSuspense>
);

HeaderFeaturesDashboard.displayName = "HeaderFeaturesDashboard";
